import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import userInfo from '../../assets/svgs/userInfo.svg';
import { authAction } from '../../store/auth-slice';

import classes from './UserInformation.module.scss';
import YesNoSection from '../Sider/YesNoSection';

export default function UserInformation() {
  const [showLogout, setShowLogout] = useState(false);
  const dispatch = useDispatch();

  const toggleModalHandler = () => {
    setShowLogout((prev) => !prev);
  };

  const logoutHandler = () => {
    dispatch(authAction.logout());
  };

  const { email, name: userName } = useSelector(
    (state) => state.authentication
  );

  const [isShow, setIsShow] = useState(false);

  const cliclHandler = () => {
    setIsShow((prev) => !prev);
  };

  const { t, i18n } = useTranslation('authForm');

  const language = i18n.language;

  return (
    <>
      {showLogout && (
        <YesNoSection
          logoutFn={logoutHandler}
          setModalHidden={toggleModalHandler}
          t={t}
          language={language}
        />
      )}
      <div
        className={`${classes['user-logo-container']} ${
          isShow && classes['active']
        }`}
        onClick={cliclHandler}
      >
        <img src={userInfo} alt="" className={classes.user} />
        {isShow && (
          <div className={classes['user-info-popup']}>
            <div className={classes['user-info']}>
              <h2>{userName}</h2>
              <a href={`mailto:${email}`}>{email}</a>
            </div>
            <div className={`${classes.buttons} ${classes[language]}`}>
              <button
                className={`${classes['hover-underline-animation']} ${classes[language]}`}
              >
                {t('My Account')}
              </button>
              <button
                className={`${classes['hover-underline-animation']} ${classes[language]}`}
              >
                {t('Theme')}
              </button>
              <button
                className={`${classes['hover-underline-animation']} ${classes[language]} `}
                onClick={toggleModalHandler}
              >
                {t('Log out')}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
